import baby from './img/baby.png';
import uchile from './img/uchile.png';
import sixbell from './img/logo-sixbell.svg';
import celerita from './img/celerita.jpg';
import vtr from './img/VTR.png';
import huawei from './img/huawei.png';
import lla from './img/lla-logo.png';
import clarovtr from './img/clarovtr.png';
import uai from './img/uai.jpg';
import scrum from './img/Scrum-Foundation.webp';
import aws from './img/aws.png';
import awscloudpracticioner from './img/aws-practicioner.png';
import blank from './img/blank.png';
import certiprof from './img/certiprof.png'
import monterrey from './img/monterrey.png'
import cordada from './img/cordada.png'
import airnguru from './img/airnguru.png'
import pixdragon from './img/pixdragon.png'
import merovingia from './img/merovingia.png'

const timelineData = [ 
    {
        text: 'Nacimiento',
        date: '1977',
        alttext:'Melipilla, 1977',
        //alttext: 'Nací en 1977 en Melipilla, hijo de empleado público y niña araucana. Mi madre es un caudal de sabiduría y mi padre de compasión y entrega. Folkloristas, pasé mi infancia entre libros y madera, aprendiendo a manejar el serrucho con mi abuelo en Laja. Fui feliz.',
        category: {
            tag: 'baby',
            color: 'white',
            img: baby,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: '',
            text: ''
        }
    },
    {
        text: 'Estudiante de Licenciatura en Ciencias mención Física, Universidad de Chile',
        date: '1995',
        alttext:'Intenté seguir la vocación.',
        //alttext: 'Quise aprender como funciona el mundo. Aprendí que no sabía nada.',
        category: {
            tag: 'education',
            color: 'white',
            img: uchile,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: 'https://ciencias.uchile.cl/carreras/4981/licenciatura-en-ciencias-con-mencion-en-fisica',
            text: 'Read more'
        }
    },
    {
        text: 'Estudiante de Ingeniería Civil en Computación e Informática, Universidad de Chile',
        date: '1999',
        alttext: 'Intenté ser útil.',
        category: {
            tag: 'education',
            color: 'white',
            img: uchile,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: 'https://www.dcc.uchile.cl/',
            text: 'Read more'
        }
    },
    {
        text: 'Programador en Sixlabs, Sixbell',
        date: '2007',
        alttext: 'Lvl1.',
        category: {
            tag: 'work',
            color: 'white',
            img: sixbell,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: 'https://www.sixbell.com/',
            text: 'Read more'
        }
    },
    {
        text: 'Jefe de Desarrollo, Celeritasoft',
        date: '2008',
        alttext: 'Da Boss.',
        category: {
            tag: 'work',
            color: 'white',
            img: celerita,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: 'https://www.youtube.com/channel/UC_E0YcxkKdpen826S2on3Rg',
            text: 'Read more'
        }
    },
    {
        text: 'Owner, pixDragon SpA',
        date: '2008',
        alttext: 'Da CEO.',
        category: {
            tag: 'work',
            color: 'white',
            img: pixdragon,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: 'www.pixdragon.net',
            text: 'Read more'
        }
    },
    {
        text: 'Ingeniero de Core & VAS, VTR Móvil',
        date: '2011',
        alttext: '¿Es muy tonto lo que estoy diciendo?.',
        category: {
            tag: 'work',
            color: 'white',
            img: vtr,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: 'https://vtr.com/productos/moviles/planes-moviles/individuales/',
            text: 'Read more'
        }
    },
    {
        text: 'SDP-OCS-ATAE Certified Engineer, Huawei University, Shenzhen, China',
        date: '2011',
        alttext: 'Me fui a las chinas.',
        category: {
            tag: 'work',
            color: 'white',
            img: huawei,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: 'https://e.huawei.com/en/talent/ict-academy/#/home',
            text: 'Read more'
        }
    },
    {
        text: 'Diplomado de Gestión de Negocios, Planificación Estratégica y Dirección de Proyectos, Universidad Adolfo Ibáñez',
        date: '2012',
        alttext: 'Diploma.',
        category: {
            tag: 'education',
            color: 'white',
            img: uai,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: 'https://ingenieria.uai.cl/?s=diplomados',
            text: 'Read more'
        }
    },
    {
        text: 'Diplomado de Gestión Comercial, eClass Universidad Adolfo Ibáñez ',
        date: '2013',
        alttext: 'Diploma.',
        category: {
            tag: 'education',
            color: 'white',
            img: uai,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: 'https://ingenieria.uai.cl/?s=diplomados',
            text: 'Read more'
        }
    },
    {
        text: 'Ingeniero de Backoffice TV',
        date: '2013',
        alttext: 'Lo que nos gusta de la vida.',
        category: {
            tag: 'work',
            color: 'white',
            img: vtr,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: 'https://vtr.com/productos/hogar-packs/tv-cable/',
            text: 'Read more'
        }
    },
    {
        text: 'Vicente',
        date: '2014',
        alttext:'Providencia, 2014',
        category: {
            tag: 'baby',
            color: 'white',
            img: baby,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: '',
            text: ''
        }
    },
    {
        text: 'TV Backoffice Engineer, Liberty Latin America',
        date: '2017',
        alttext: 'Me la pasé en el Caribe.',
        category: {
            tag: 'work',
            color: 'white',
            img: lla,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: 'https://lla.com/',
            text: 'Read more'
        }
    },
    {
        text: 'Leonor',
        date: '2020',
        alttext:'Providencia, 2020',
        category: {
            tag: 'baby',
            color: 'white',
            img: baby,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: '',
            text: ''
        }
    },
    {
        text: 'SCRUM Foundations Professional Certificate SFPC, Certiprof',
        date: '2020',
        alttext: 'Certificación.',
        category: {
            tag: 'certifications',
            color: 'white',
            img: certiprof,
            img2: scrum,
            hasimg2: true
        },
        link: {
            url: 'https://certiprof.com/collections/scrum',
            text: 'Read more'
        }
    },
    {
        text: 'AWS Certified Cloud Practicioner Issued Sep 2021',
        date: '2021',
        alttext: 'Certificación.',
        category: {
            tag: 'certifications',
            color: 'white',
            img: aws,
            img2: awscloudpracticioner,
            hasimg2: true
        },
        link: {
            url: 'https://www.credly.com/badges/37f04dbe-b2a4-4886-9e05-617c264cbee7'
        }
    },    
    {
        text: 'TV Backoffice Engineer, ClaroVTR',
        date: '2022',
        alttext: 'Y, sí.',
        category: {
            tag: 'work',
            color: 'white',
            img: clarovtr,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: 'https://www.clarochile.cl/',
            text: 'Read more'
        }
    },
    {
        text: 'Curso de Ingeniero de Proyectos',
        date: '2024',
        alttext: 'Hay que estudiar.',
        category: {
            tag: 'work',
            color: 'blue',
            img: monterrey,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: 'https://tec.mx/es/profesional?utm_campaign=PERF&utm_source=google&utm_medium=pmax&utm_content=pmax&utm_cve_periodo_iniciativa=202513&utm_cve_sede_iniciativa=NAL&PAUTA=/1&gclsrc=aw.ds&gad_source=1',
            text: 'Read more'
        }
    },
    {
        text: 'Software Engineer in Infrastructure, Cordada',
        date: '2025',
        alttext: 'Volviendo al desarrollo.',
        category: {
            tag: 'work',
            color: '#010101',
            img: cordada,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: 'https://www.cordada.com',
            text: 'Read more'
        }
    },
    {
        text: 'Owner, merovingia',
        date: '2026',
        alttext: 'Tienda Online de Juegos de Mesa.',
        category: {
            tag: 'work',
            color: '#white',
            img: merovingia,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: 'https://www.merovingia.cl',
            text: 'Read more'
        }
    },
    {
        text: 'Software Engineer, Airnguru',
        date: '2026',
        alttext: 'Más desarrollo.',
        category: {
            tag: 'work',
            color: '#white',
            img: airnguru,
            img2: blank,
            hasimg2: false
        },
        link: {
            url: 'https://www.airnguru.com',
            text: 'Read more'
        }
    }
];

export default timelineData;